const EVENT = 'fokus:date-popover-open';

/** Tell every other date popover to close. */
export function announceDatePopover(id) {
  if (typeof window === 'undefined' || !id) return;
  window.dispatchEvent(new CustomEvent(EVENT, { detail: { id } }));
}

export function onOtherDatePopover(id, close) {
  const handler = (event) => {
    if (event.detail?.id !== id) close();
  };
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
}
